import React from "react";
import { Trans, useTranslation } from "react-i18next";
import PageHeader from "components/common/PageHeader";
import { ExternalLink } from "components/common";
import EmbeddedGCPApp from "./EmbeddedGCPApp";
const GCPApp = () => {
  const { t } = useTranslation("enterprise_integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: t("gcp.app.title") }, /* @__PURE__ */ React.createElement("span", null, t("gcp.app.description")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "gcp.app.requirement",
      components: { externalLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://console.cloud.google.com" }) }
    }
  ), " ")), /* @__PURE__ */ React.createElement(EmbeddedGCPApp, null));
};
export default GCPApp;
